import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Grid, Typography, Box, Container } from '@mui/material';
import CustomButton from 'components/CustomButton';
import useIsMobile from 'hooks/useIsMobile';

export default function OfferTrial() {
  const isMobile = useIsMobile();

  return (
    <>
      <Head>
        <title>Free 7-day trial at Mind the Graph</title>

        <meta
          key="description"
          name="description"
          content="Experience 7 days of premium subscription benefits for free at Mind the Graph, the best tool to boost your paper with the power of infographics."
        />

        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <Container>
        <Box textAlign="center" pt={6}>
          <Image src="/images/mtg-logo-red.svg" alt="Mind the Graph" width={200} height={50} />

          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center" pt={isMobile ? 6 : 4}>
                <Image src="/images/not-found.svg" alt="Not found page" width={357} height={330} />
              </Box>
            </Grid>

            <Grid item md={6} xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={isMobile ? 0 : 10}
                gap={5}
                mt={isMobile ? -4 : 0}
              >
                <Box>
                  <Typography variant="h1" style={{ fontSize: 28 }} mt={5}>
                    <b>Ops...</b>
                  </Typography>

                  <Typography variant="body1" style={{ fontSize: 18 }} mt={2}>
                    This offer is no longer available. <br />
                    <b>Visit the pricing page</b> and choose the subscription that best suits your
                    needs.
                  </Typography>

                  <Box pt={6} gap={3} display="flex" justifyContent="center">
                    <CustomButton variant="ctaPrimaryOutline" href="/">
                      Home Page
                    </CustomButton>

                    <CustomButton href="/pricing">Pricing Page</CustomButton>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}
